<template>
  <div class="inline-flex gap-1 align-center">
    <span data-testid="main-item-name">
      {{ mainItem.name }}
    </span>

    <VMenu>
      <template #activator="{ props }">
        <VChip
          v-bind="props"
          @click.capture.prevent
          size="small"
          density="compact"
          :rounded="'pill'"
          class="font-semibold"
          data-testid="items-chip-number"
        >
          + {{ menuItems.length }}
        </VChip>
      </template>

      <VList class="pa-0">
        <div v-for="(item, index) in menuItems" :key="item.id" data-testid="list-item">
          <p class="px-4 py-2 text-xs font-semibold">{{ item.name }}</p>
          <DividerLine v-if="index < menuItems.length - 1" />
        </div>
      </VList>
    </VMenu>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import DividerLine from '@/atoms/DividerLine.vue'

interface Item {
  id: string
  name: string
}

interface Props {
  items: Item[]
  mainItemId: string
}

const { items, mainItemId } = defineProps<Props>()

const mainItem = computed<Item>(() => {
  const foundLabel = items.find((item) => item.id === mainItemId)

  if (!foundLabel) {
    return items[0]
  }

  return foundLabel
})

const menuItems = computed(() => {
  return items.filter((item) => item.id !== mainItem.value.id)
})
</script>

<style scoped></style>
